namespace Areas.Employee {
    "use strict";
  
    export function newDefaultJob(e) {

        e.data.employeeId = $('#WorkOrderGrid').dxDataGrid('instance').option('EmployeeId');
        e.data.isIncluded = true;
    }

    export function newTimeEntryRight(e) {

        e.data.employeeId = $('#TimeEntryRightsGrid').dxDataGrid('instance').option('EmployeeId');
    }

    var activityAdd: UpdateOperations;

    var formCrudOps: FormCrudOperations;

    export function addActivityRecord(e: any) {

        activityAdd = new UpdateOperations("AddActivityForm", "/Employee/Activity/Save");
        activityAdd.updateRecord(() => {
            $('#AddActivityPopup').dxPopup('hide');
            $('#ActivityGrid').dxDataGrid('instance').refresh();
            $('#ActivityScheduler').dxScheduler('instance').repaint();
        });
    }


    export function viewLink(cellElement, cellInfo) {
        const employeeId = String(cellInfo.data.employeeId);
        const startDate = String(cellInfo.data.weekEndingDate);
        const linkInfo = `<a href= '/Employee/Time/Index/${employeeId}?start=${startDate}' target=_blank >View</a>`;
        cellElement.html(linkInfo);
    }

    export function viewLinkProject(cellElement, cellInfo) {
        const accountCode = String(cellInfo.data.project);
        let projectId = cellInfo.data.accountId;
        const linkInfo = `<a href= 'https://project.capnet.ucla.edu/Account/FinanceRechargeJob/View/${projectId}' target=_blank> ${accountCode}</a>`;
        cellElement.html(linkInfo);
    }

    export function viewLinkProjectFromJobs(cellElement, cellInfo) {
        const accountCode = String(cellInfo.data.accountCode);
        let projectId = cellInfo.data.accountId;
        const linkInfo = `<a href= 'https://project.capnet.ucla.edu/Account/FinanceRechargeJob/View/${projectId}' target=_blank> ${accountCode}</a>`;
        cellElement.html(linkInfo);
    }








   
   
}